var _desc, _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M4.33 15.48L14.51 5.76L16.95 8.1L6.77 17.82L3.59 18.52L4.33 15.48ZM18.13 2.31C18.37 2.07 18.66 2.04 18.8 2.04C18.95 2.04 19.24 2.07 19.48 2.31L20.58 3.35C20.82 3.58 20.86 3.86 20.86 4C20.86 4.14 20.82 4.41 20.58 4.64L18.47 6.66L16.02 4.32L18.13 2.31ZM1.94 20.98L7.85 19.67L22.09 6.09C23.3 4.93 23.3 3.06 22.09 1.91L20.99 0.86C20.39 0.28 19.6 0 18.8 0C18.01 0 17.22 0.28 16.61 0.86L2.38 14.45L1.02 20.09C0.9 20.56 1.29 21 1.77 21C1.83 21 1.88 20.99 1.94 20.98Z",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36197",
    x: 1,
    y: 22,
    rx: 1,
    width: 22,
    height: 2,
    fill: "#50964E",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.6033e0aa193d0e4e1e446ad614fbde28.svg";
export { ForwardRef as ReactComponent };